import { Redirect, useParams,useLocation } from 'react-router-dom';
import React, { useState,useContext } from 'react';
import { Auth } from "aws-amplify";
import { login } from "../../apis/auth";
import { createSession,isUserLoggedIn } from '../../apis/sessionUtil';
import {PageContext} from '../../PageContext';
import {PAGE} from "../../constants"
import {getLoginMessage,setLoginMessage} from "../../apis/sharedata"

export function Login() {
    
    const [isLoggedIn, setIsLoggedIn] = useState(()=>isUserLoggedIn());
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [showSignUp,setShowSignUp] = useState("");
    const [showForgetPassword, setShowForgetPassword] = useState("");
    const [formError,setFormError] = useState("");
    const {page, setPage} = useContext(PageContext);
    // const location = useLocation();

    
    let displayMessage;
    // if(location.state){
    //     displayMessage = <p> { `${location.state.message}` } </p>;
    // }

     function handleLogin(event) {
        event.preventDefault();
        console.log("Login.handleLogin: Inside login");
        login(userName,password,setIsLoggedIn,handleLoginError);
        displayMessage = "Login in Progress.."
    }

    function handleLoginError(errMessage){
        if(errMessage === "Password attempts exceeded"){
            errMessage = errMessage + " Contact your Administrator"
        }
        setFormError(errMessage);
    }
        
    

    function redirectToSignUp(event) {
        event.preventDefault();
        // setShowSignUp(true);
        setPage(PAGE.SIGNUP);
    }

    function redirectToForgetPassword(event){
        event.preventDefault();
        // setShowForgetPassword(true);
        setPage(PAGE.FORGETPASSWORD);
    }

    // if(showSignUp){
    //     return <Redirect to='/SignUp' />
    // }

    if(showForgetPassword){
        console.log("Show ForgetPassword")
        return <Redirect to='/ForgotPassword' />
    }

    if (isLoggedIn) {
        // console.log("Login: Redirect to Home page")
        // return <Redirect to='/Home' />
        setLoginMessage("");
        setPage(PAGE.HOME);
    }
    
    return (

        <div style={{background:"#244784"}}>
        <div className="topcontainer">
            <div className="container">
                <div className="row">
                    {/* <div className="col">
                        <a href="#" className="fb btn">
                            <i className="fa fa-facebook fa-fw"></i> Login with Facebook
                        </a>
                        <a href="#" className="twitter btn">
                            <i className="fa fa-twitter fa-fw"></i> Login with Twitter
                        </a>
                        <a href="#" className="google btn"><i className="fa fa-google fa-fw">
                        </i> Login with Google+
                        </a>
                    </div>
                    <div className="col">

                        <div class="vl">
                            <span class="vl-innertext">or</span>
                        </div>
                        <div class="hide-md-lg">
                            <p>Or sign in manually:</p>
                        </div> */}
                    <div className="col">
                        <div style={{color:'#244784', textAlign:'center'}}>
                        <h2>Login</h2>

                        <h4>Please provide your login credentials below</h4>
                        </div>

                        {getLoginMessage()}
                        {formError && <p style={{color:"red"}}>{formError}</p>}


                        <form onSubmit={handleLogin}>
                            <input type="text" name="username" value={userName}  onChange={(event) => setUserName(event.target.value)} className="ipt ipc" style={{backgroundColor:'#f4f4f4'}} placeholder="Email address" required />
                            <input type="password" name="password" value={password} onChange={(event)=>setPassword(event.target.value)} className="ipt ipc" style={{backgroundColor:'#f4f4f4'}} placeholder="Password" required />

                                <a href="" onClick={redirectToForgetPassword}>Forgot password?</a>

                            <input type="submit" className="ips ipc" value="LOGIN" />
                        </form>

                        {/* <div style={{color:'#244784', textAlign:'center'}}>
                        <h2>SIGN UP</h2>

                        <h4>Create Your Account By Signing Up</h4>
                        </div> */}

                    <div onClick={redirectToSignUp} style={{color:'#244784', textAlign:'center'}}>
                    <h4>Don't Have An Account Yet?</h4>
                    <h4><a href="">Sign Up Now</a></h4>
                    {/* <br/>
                    <a href="" style={{ color: "#244784" }}  onClick={redirectToSignUp}>Sign up</a> */}
                    </div>

                    <div className="row">


{/* 
                    <div className="col">
                        <a href="" style={{ color: "#244784" }}  onClick={redirectToSignUp}>Sign up</a>
                    </div> */}

                    {/* <div className="col">
                        <a href="" style={{ color: "white" }} class="btn" onClick={redirectToForgetPassword}>Forgot password?</a>
                    </div> */}
                    </div>


                    </div>
                </div>
            </div>
            {/* <div className="bottom-container">
            </div> */}
        </div>
        </div>

    );
}